/* istanbul ignore file */
import { Link } from 'react-router-dom';
import { NEW_TAB_LINK_PROPS } from 'framework/utils';
import { useProjectUrl } from '../route/route';

const ProjectLink = ({
  id,
  name,
  isClickable = true,
  isOpenInNewTab,
}: {
  id: StringOrNumber;
  name: string;
  isClickable?: boolean;
  isOpenInNewTab?: boolean;
}) => {
  const { getSingleEntityUrl } = useProjectUrl();

  return (
    <>
      {isClickable ? (
        <Link to={getSingleEntityUrl(id)} {...(isOpenInNewTab && NEW_TAB_LINK_PROPS)}>
          {name}
        </Link>
      ) : (
        <span>{name}</span>
      )}
    </>
  );
};

export default ProjectLink;
